import React from 'react';
import { ChevronDown } from 'lucide-react';
import './ShowMore.css';

/**
 * Baustein — Show-More.
 * Inline-Expand-Trigger unter List, TileGrid oder ähnlichen Containern.
 * Klick blendet versteckte Items ein — keine Navigation, keine Sub-Page.
 *
 * Zweck: lange Sektionen kompakt halten, damit nachfolgende Sektionen ohne
 * Scrollen erreichbar sind. Wer wirklich alle Items will, klickt einmal.
 *
 * Verwendung:
 *   <List>{visibleItems.map(...)}</List>
 *   {hasMore && (
 *     <ShowMore onClick={() => setExpanded(true)}>
 *       Alle {total} anzeigen
 *     </ShowMore>
 *   )}
 *
 * Props:
 *   children — Label (z.B. „Alle 23 anzeigen")
 *   onClick  — Click-Handler
 *   icon     — optional eigenes Icon (default: ChevronDown)
 */
export default function ShowMore({ children, onClick, icon: Icon = ChevronDown }) {
  return (
    <button type="button" className="show-more" onClick={onClick}>
      <span>{children}</span>
      <Icon size={14} aria-hidden />
    </button>
  );
}
